<template>
  <div class="vue-page-container">
    <div
      class="vue-page-banner"
      :class="{
        'vue-page-banner--with-banner-content': bannerContentComponent,
      }"
      :style="bannerImageBackgroundStyle"
    >
      <img
        v-if="bannerImageForeground"
        :src="bannerImageForeground"
        class="vue-page-banner__image"
      />
      <div
        v-if="bannerContentComponent"
        class="vue-page-banner__content"
      >
        <component :is="bannerContentComponent" />
      </div>
    </div>
    <component
      v-if="subLayoutData"
      :is="subLayoutComponent"
      :layoutProps="subLayoutProps"
      :subLayoutData="childLayoutData"
    >
      <slot></slot>
    </component>
    <slot v-else></slot>
  </div>
</template>

<script>
import BlankLayout from "@/layouts/BlankLayout.vue"

const LeagueOfLegendsImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2xlYWd1ZW9mbGVnZW5kcy9nYW1lLWJhbm5lcl9iYWNrZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTkyMCwiaGVpZ2h0IjoyNzksImZpdCI6ImNvdmVyIn19fQ=="
const CSGOBannerImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2NzZ28vZ2FtZS1iYW5uZXJfYmFja2dyb3VuZC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjE5MjAsImhlaWdodCI6Mjc5LCJmaXQiOiJjb3ZlciJ9fX0="
const FortniteBannerImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2ZvcnRuaXRlL2dhbWUtYmFubmVyX2JhY2tncm91bmQucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxOTIwLCJoZWlnaHQiOjI3OSwiZml0IjoiY292ZXIifX19"
const SSBUImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL3N1cGVyLXNtYXNoLWJyb3MtdWx0aW1hdGUvZ2FtZS1iYW5uZXJfYmFja2dyb3VuZC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjE5MjAsImhlaWdodCI6Mjc5LCJmaXQiOiJjb3ZlciJ9fX0="
const OverwatchImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL292ZXJ3YXRjaC9nYW1lLWJhbm5lcl9iYWNrZ3JvdW5kLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MTkyMCwiaGVpZ2h0IjoyNzksImZpdCI6ImNvdmVyIn19fQ=="
const HearthstoneImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL2hlYXJ0aHN0b25lL2dhbWUtYmFubmVyX2JhY2tncm91bmQucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxOTIwLCJoZWlnaHQiOjI3OSwiZml0IjoiY292ZXIifX19"
const MTGAImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL21hZ2ljLXRoZS1nYXRoZXJpbmcvZ2FtZS1iYW5uZXJfYmFja2dyb3VuZC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjE5MjAsImhlaWdodCI6Mjc5LCJmaXQiOiJjb3ZlciJ9fX0="
const ValorantImageBackground = "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL3ZhbG9yYW50L2dhbWUtYmFubmVyX2JhY2tncm91bmQucG5nIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxOTIwLCJoZWlnaHQiOjI3OSwiZml0IjoiY292ZXIifX19"

export default {
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {
          bannerImageBackground: null,
          bannerImageForeground: null,
          automatedBackground: false,
        }
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    subLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    subLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    childLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
    bannerImageBackgroundStyle () {
      let bannerImageBackground
      if (this.layoutProps.automatedBackground) {
        const gameToBackground = {
          "leagueoflegends": LeagueOfLegendsImageBackground,
          "csgo": CSGOBannerImageBackground,
          "fortnite": FortniteBannerImageBackground,
          "super-smash-bros-ultimate": SSBUImageBackground,
          "overwatch": OverwatchImageBackground,
          "hearthstone": HearthstoneImageBackground,
          "magic-the-gathering": MTGAImageBackground,
          "valorant": ValorantImageBackground,
        }
        bannerImageBackground = gameToBackground[this.$route.params.game]
      } else {
        bannerImageBackground = this.layoutProps.bannerImageBackground
      }

      return bannerImageBackground ? {
        "background-image": "url('" + bannerImageBackground + "')",
      } : null
    },
    bannerImageForeground () {
      return this.layoutProps.bannerImageForeground
    },
    bannerContentComponent () {
      return this.layoutProps.bannerContentComponent
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layouts/BannerLayout.vue